import { render, staticRenderFns } from "./model-leftMenu.vue?vue&type=template&id=10cc85e0&scoped=true&"
import script from "./model-leftMenu.vue?vue&type=script&lang=js&"
export * from "./model-leftMenu.vue?vue&type=script&lang=js&"
import style0 from "./model-leftMenu.vue?vue&type=style&index=0&id=10cc85e0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc85e0",
  null
  
)

export default component.exports